import { render } from "./MessageCom.vue?vue&type=template&id=86a7689c"
import script from "./MessageCom.vue?vue&type=script&lang=js"
export * from "./MessageCom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__